import * as React from 'react';

//hook
import { useState } from 'react';
import { NotificationConsumer } from '../hooks/context/NotificationContext';
import { UserConsumer } from '../hooks/context/UserContext';

//type
import { signupReqType } from '../api/signup/type/SignupType';

//api
import { PostSignup } from '../api/signup/PostSignup';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//image
import apple from "../assets/login/apple.png"
import google from "../assets/login/google.png"
import { Phone } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface signupProps {
  openSignup: boolean,
  setOpenSignup: (open: boolean) =>void
  setOpenOtp: (open: boolean) =>void
}


const Signup = ({openSignup, setOpenSignup, setOpenOtp} : signupProps) => {
  const { t } = useTranslation();
  const [showPass, setShowPass] = useState<boolean>(false)
  const [loading, setLoading] = useState<Boolean>(false)
  let {setNoteMessage, setShowMessage, setStatusCode} = NotificationConsumer()
  let {setUserData} = UserConsumer()

  const handleClose = () => {
    setOpenSignup(false)
    setShowPass(false)
  };
  const SignupSchema = Yup.object().shape({
    full_name: Yup.string().required(t("full_name_required")),
    email: Yup.string().email(t("invalid_email")).required(t("email_required")),
    password: Yup.string().min(8, t("password_lenght")).required(t("password_required")),
    phone: Yup.string()
      //test(name, message, testFunction)
      .test(
        "len",t("phone_lenght"),
        (value) => {
          if (!value) return false;
          const numberWithoutCode = value.slice(4);
          return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
        }
      ).required(t("phone_required")),
  });

  const handleSubmit = async (values: signupReqType)=> {
    try {
      setLoading(true)
      const result = await PostSignup(values);
      console.log('Signup successful:');
      if(result.code == 200) {
        setNoteMessage(result.message)
        setShowMessage(true)
        setStatusCode(result.code)
        if (result.data.token) {
          localStorage.setItem("token", result.data.token);
        }
        setOpenOtp(true)
        setOpenSignup(false)
        setUserData(result.data)
      }
      else {
        setNoteMessage(result.message)
        setShowMessage(true)
        setStatusCode(result.code)
      }
      handleClose();
    }
    catch (error:any) {
        console.error('Signup failed', error);
        setNoteMessage(error.response.data.message)
        setShowMessage(true)
        setStatusCode(error.status)
    }
    finally {
      setLoading(false)
    }
  }
  return (
    <div>
        <Dialog 
        open={openSignup}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
        disableRestoreFocus
        maxWidth="md"
        fullWidth 
        >
          <div className='flex justify-between max-sm:flex-col pb-5'>
            <div className='w-full'>
              <DialogTitle>{t("create_new_account")}</DialogTitle>
              <DialogContent>
                <Formik
                initialValues={{ full_name: '', email: '', password: '', phone: '' }}
                validationSchema={SignupSchema}
                onSubmit={(values)=>handleSubmit(values)}
                >
              {({ values,touched, errors,setFieldValue }) => (
                <Form>
                  <div className="sm:flex gap-2 mt-2">
                    <Field
                      as={TextField}
                      name="full_name"
                      label={t("full_name")}
                      className="sm:w-1/2 w-full"
                      helperText={touched.full_name && errors.full_name ? errors.full_name : ""}
                      error={touched.full_name && Boolean(errors.full_name)}
                    />
                    <Field
                      as={TextField}
                      name="email"
                      type="email"
                      label={t("email")}
                      className="sm:w-1/2 w-full"
                      helperText={touched.email && errors.email ? errors.email : ""}
                      error={touched.email && Boolean(errors.email)}
                    />
                  </div>

                  <div className="mt-5">
                    <Field
                      as={TextField}
                      name="password"
                      type={showPass ? "text" : "password"}
                      label={t("password")}
                      className="w-full !mb-5"
                      autoComplete="password"
                      helperText={touched.password && errors.password ? errors.password : ""}
                      error={touched.password && Boolean(errors.password)}
                      InputProps={{
                        endAdornment: (
                            <IconButton onClick={()=>setShowPass((prev)=>!prev)}>
                              {showPass ? <Visibility/> : <VisibilityOff/>}
                            </IconButton>
                        ),
                      }}
                    />
                    <PhoneInput
                      country={"sy"}
                      onlyCountries={["sy"]}
                      disableDropdown={true}
                      enableSearch={true}
                      value={values.phone}
                      onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                      inputStyle={{
                        borderRadius: "4px",
                        width: "100%",
                        height: "56px",
                        border: touched.phone && errors.phone ? "1px solid red" : "",
                      }}
                      buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                      containerStyle={{
                        display: "flex",
                        flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                      }}
                      inputProps={{
                        autoComplete: "phone",
                      }}
                    />
                    <div className="text-red-500 text-sm mt-1">
                      {touched.phone && errors.phone ? errors.phone : ""}
                    </div>
                  </div>

                  <DialogActions className={` ${i18n.language === "en" ? "!justify-start" : "!justify-start"}`}>
                    <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' type="submit">
                      {loading 
                      ? <CircularProgress className='w-1 h-1'/>
                      :t("confirm")
                      }
                    </Button>
                  </DialogActions>
                </Form>
              )}
                </Formik>
              </DialogContent>
            </div>
          <div className='flex flex-col items-center'>
            <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
            <div className=''>{i18n.language === "en" ? "Or" : "أو"}</div>
            <div className='w-[3px] h-full bg-[#D9D9D9]'></div>
          </div>
            <div className='w-full'>
            <DialogTitle className='flex gap-3'>
              <p className="whitespace-pre-line">{t("download_from_app")}</p>
            </DialogTitle>
            <DialogContent>
              <DialogActions>
                <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                  <div>
                    <img src={apple} alt='no-photo'/>
                  </div>
                  <div>
                    {t("apple")}
                  </div>
                </Button>
              </DialogActions>
              <DialogActions>
                <Button className='w-full gap-2 h-[49px] !bg-[#EDEDED] !text-black !font-bold !rounded-full'>
                  <div>
                    <img src={google} alt='no-photo'/>
                  </div>
                  <div>
                    {t("google")}
                  </div>
                </Button>
              </DialogActions>
            </DialogContent>
            </div>
          </div>
        </Dialog>
    </div>
  )
}

export default Signup